// Local translations
export const T = {
  en_GB: {
    title: "Product Selections",
    description: "Products in this asset class ordered by rank.",
    rank: "Rank",
    name: "Name",
    isin: "ISIN",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    noSelections: "No products are assigned to this asset class.",
    close: "Close",
    moveUp: "Move up",
    moveDown: "Move down",
    failedToReorder: "Failed to reorder product",
  },
  nb_NO: {
    title: "Produktutvalg",
    description: "Produkter i denne aktivaklassen sortert etter rangering.",
    rank: "Rang",
    name: "Navn",
    isin: "ISIN",
    status: "Status",
    active: "Aktiv",
    inactive: "Inaktiv",
    noSelections: "Ingen produkter er tilordnet denne aktivaklassen.",
    close: "Lukk",
    moveUp: "Flytt opp",
    moveDown: "Flytt ned",
    failedToReorder: "Kunne ikke endre rekkefølgen",
  },
} as const;
